export default [

     {
          path: '/service-model-map',
          name: 'ServiceModelMap',
          component: () => import("@/views/Page/ServiceModelMap/ServiceModelMap.vue"),
           meta: {
               title: 'ServiceModelMap',
          },
     }
];